const routes = [
  {
    path: '/payment-agreements',
    name: 'PaymentAgreements',
    component: () => import('./pages/AgreementsSettings.vue'),
    meta: {
      title: 'Мои курсы',
      authorize: [],
    },
  },
  {
    path: '/list-enrollments',
    name: 'ListEnrollments',
    component: () => import('./pages/EnrollmentList.vue'),
    meta: {
      title: 'Списки зачисления',
      authorize: [],
    },
  },
  {
    path: '/document-constructor/:id',
    name: 'ConstructorDocument',
    component: () => import('./pages/ConstructorDocument.vue'),
    meta: {
      title: 'Политики и положения',
      authorize: [],
      layout: 'empty-layout',
    },
  },
  {
    path: '/document-view/:id',
    name: 'ConstructorDocumentView',
    component: () => import('./pages/ConstructorDocument.vue'),
    meta: {
      layout: 'empty-layout',
      readonly: true,
    },
  },
  {
    path: '/sign-contract/:id',
    name: 'SignContract',
    component: () => import('./pages/SignContract.vue'),
    meta: {
      authorize: [],
    },
  },
  {
    path: '/contract-view/:id',
    name: 'ContractView',
    component: () => import('./pages/ContractView.vue'),
    meta: {
      title: 'Просмотр договора',
      breadcrumbs: {
        parent: 'EducationCourseList',
      },
    },
  },
];

export default routes;
